var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('room-style-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var primaryButton = ref.primaryButton;
var buttonIconStyles = ref.buttonIconStyles;
var iconStyle = ref.iconStyle;
return [_c('button',{staticClass:"ws-button",class:_vm.buttonClasses,style:(_vm.styled ? primaryButton : ''),on:{"click":_vm.handleClick}},[(_vm.icon)?_c('span',{class:['ws-icon', _vm.icon],style:(_vm.styled ? buttonIconStyles : iconStyle)}):_vm._e(),_c('span',{staticClass:"ws-button__text"},[_vm._t("default")],2)])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }